module.exports = __webpack_public_path__ + "img/CRT_Sword-002.d19c27ac.png";